import { __decorate, __param } from 'tslib';
import { ElementRef, Input, Directive, Self, Component, ChangeDetectorRef, EventEmitter, ɵɵdefineInjectable, Injectable, Output, ViewChild, NgModule, ComponentFactoryResolver, ApplicationRef, Injector, ɵɵinject, INJECTOR } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgControl } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/router';

function AlertComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.options == null ? null : ctx_r0.options.headerTitle, " ");
} }
function AlertComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.options == null ? null : ctx_r1.options.msg, " ");
} }
function AlertComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r3.options == null ? null : ctx_r3.options.msg, ɵngcc0.ɵɵsanitizeHtml);
} }
function AlertComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function AlertComponent_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.cancel(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("class", ctx_r4.cancelBtnClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.options == null ? null : ctx_r4.options.cancelText, " ");
} }
function ModalComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 4);
} }
const _c0 = ["*", [["", "actions", ""]]];
const _c1 = ["*", "[actions]"];
function SideBarLinkComponent_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2)(1, "a", 3);
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelementStart(3, "span", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6)(7, "ul", 7);
    ɵngcc0.ɵɵprojection(8);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("class", ctx_r0.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.description);
} }
const _c2 = function (a0) { return { exact: a0 }; };
function SideBarLinkComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 8)(1, "a", 9);
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelementStart(3, "span", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction1(4, _c2, ctx_r2.exactLink));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r2.route);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("class", ctx_r2.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.description);
} }
const _c3 = ["*"];
const _c4 = ["ch-side-bar", ""];
function SideBarComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.appName, " ");
} }
function SideBarComponent_ul_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 16);
    ɵngcc0.ɵɵelement(1, "li", 17);
    ɵngcc0.ɵɵelementStart(2, "li", 17)(3, "a", 18);
    ɵngcc0.ɵɵelement(4, "i");
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("class", ctx_r1.expandButtonIconClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("class", ctx_r1.expandButtonTextClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.expandButtonData == null ? null : ctx_r1.expandButtonData.text);
} }
const _c5 = function (a0, a1) { return { width: a0, height: a1 }; };
const _c6 = function (a0, a1) { return { maxWidth: a0, maxHeight: a1 }; };
const _c7 = ["ch-top-bar", ""];
const _c8 = ["ch-top-bar-breadcrumb", ""];
function TopBarBreadcrumbComponent_ng_container_0_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("class", ctx_r4.icon);
} }
function TopBarBreadcrumbComponent_ng_container_0_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.path, " ");
} }
function TopBarBreadcrumbComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2)(2, "a", 3);
    ɵngcc0.ɵɵtemplate(3, TopBarBreadcrumbComponent_ng_container_0_i_3_Template, 1, 1, "i", 0);
    ɵngcc0.ɵɵtemplate(4, TopBarBreadcrumbComponent_ng_container_0_span_4_Template, 2, 1, "span", 0);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ctx_r0.title || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.path && ctx_r0.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.path);
} }
function TopBarBreadcrumbComponent_ng_container_1_div_1_a_1_ng_template_1_Template(rf, ctx) { }
const _c9 = function (a0, a1) { return { item: a0, i: a1 }; };
const _c10 = function (a0) { return { $implicit: a0 }; };
function TopBarBreadcrumbComponent_ng_container_1_div_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵtemplate(1, TopBarBreadcrumbComponent_ng_container_1_div_1_a_1_ng_template_1_Template, 0, 0, "ng-template", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const item_r7 = ctx_r13.$implicit;
    const i_r8 = ctx_r13.index;
    ɵngcc0.ɵɵnextContext(2);
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("title", item_r7.title || "")("routerLink", item_r7.route)("queryParams", item_r7.queryParams);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(8, _c10, ɵngcc0.ɵɵpureFunction2(5, _c9, item_r7, i_r8)));
} }
function TopBarBreadcrumbComponent_ng_container_1_div_1_ng_template_2_ng_template_1_Template(rf, ctx) { }
function TopBarBreadcrumbComponent_ng_container_1_div_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵtemplate(1, TopBarBreadcrumbComponent_ng_container_1_div_1_ng_template_2_ng_template_1_Template, 0, 0, "ng-template", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    const item_r7 = ctx_r15.$implicit;
    const i_r8 = ctx_r15.index;
    ɵngcc0.ɵɵnextContext(2);
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("title", item_r7.title || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c10, ɵngcc0.ɵɵpureFunction2(3, _c9, item_r7, i_r8)));
} }
const _c11 = function (a0) { return { active: a0 }; };
function TopBarBreadcrumbComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtemplate(1, TopBarBreadcrumbComponent_ng_container_1_div_1_a_1_Template, 2, 10, "a", 6);
    ɵngcc0.ɵɵtemplate(2, TopBarBreadcrumbComponent_ng_container_1_div_1_ng_template_2_Template, 2, 8, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const _r10 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c11, item_r7.active));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r7.route)("ngIfElse", _r10);
} }
function TopBarBreadcrumbComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TopBarBreadcrumbComponent_ng_container_1_div_1_Template, 4, 5, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.paths);
} }
function TopBarBreadcrumbComponent_ng_template_2_i_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("class", ctx_r17.icon);
} }
function TopBarBreadcrumbComponent_ng_template_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1, "/");
    ɵngcc0.ɵɵelementEnd();
} }
function TopBarBreadcrumbComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TopBarBreadcrumbComponent_ng_template_2_i_0_Template, 1, 1, "i", 0);
    ɵngcc0.ɵɵtemplate(1, TopBarBreadcrumbComponent_ng_template_2_span_1_Template, 2, 0, "span", 11);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r16 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.icon && data_r16.i == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", data_r16.i > 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", data_r16.item.title, " ");
} }
const _c12 = ["ch-search-form", ""];
const _c13 = function (a0) { return { "basic": a0 }; };
const _c14 = function (a0) { return { "loading": a0 }; };
function SearchFormComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div")(2, "button", 10);
    ɵngcc0.ɵɵlistener("click", function SearchFormComponent_ng_container_0_Template_button_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.toggle($event); });
    ɵngcc0.ɵɵelement(3, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 12);
    ɵngcc0.ɵɵlistener("click", function SearchFormComponent_ng_container_0_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.search(); });
    ɵngcc0.ɵɵelement(5, "i", 13);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("class", "tiny ui icon buttons " + ctx_r0.defaultSearchBtnPosition);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(13, _c13, ctx_r0.hidden))("content", ctx_r0.hidden ? ctx_r0.hiddenSearchBtnTooltip : ctx_r0.visibleSearchBtnTooltip)("is-inverted", ctx_r0.tootipIsInverted)("position", ctx_r0.tootipIsInvertedPosition)("is-html", false);
    ɵngcc0.ɵɵattribute("class", "ui " + ctx_r0.color + " button" + (ctx_r0.hidden ? " basic" : ""));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c14, ctx_r0.loading))("content", ctx_r0.updateBtnTooltip)("is-inverted", ctx_r0.tootipIsInverted)("is-html", false)("position", ctx_r0.tootipIsInvertedPosition);
    ɵngcc0.ɵɵattribute("class", "ui " + ctx_r0.color + " button basic");
} }
function SearchFormComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "button", 14);
    ɵngcc0.ɵɵlistener("click", function SearchFormComponent_ng_template_1_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.toggle($event); });
    ɵngcc0.ɵɵelement(2, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 14);
    ɵngcc0.ɵɵlistener("click", function SearchFormComponent_ng_template_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.search(); });
    ɵngcc0.ɵɵelement(4, "i", 13);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("class", "tiny ui icon buttons " + ctx_r2.defaultSearchBtnPosition);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c13, ctx_r2.hidden));
    ɵngcc0.ɵɵattribute("class", "ui " + ctx_r2.color + " button" + (ctx_r2.hidden ? " basic" : ""));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c14, ctx_r2.loading));
    ɵngcc0.ɵɵattribute("class", "ui " + ctx_r2.color + " button basic");
} }
const _c15 = [[["", "extra-buttons", ""]], "*"];
const _c16 = ["[extra-buttons]", "*"];
const _c17 = ["ch-grid-column", ""];
const _c18 = ["ch-hdivider", ""];
const _c19 = function (a0) { return { "hidden": a0 }; };
function DialogComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 13);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.title, ɵngcc0.ɵɵsanitizeHtml);
} }
function DialogComponent_div_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.title);
} }
function DialogComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, DialogComponent_div_5_div_1_Template, 1, 1, "div", 11);
    ɵngcc0.ɵɵtemplate(2, DialogComponent_div_5_ng_template_2_Template, 2, 1, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.titleIsHtml)("ngIfElse", _r2);
} }
const _c20 = function (a0) { return { width: a0 }; };
const _c21 = ["ch-accordion", ""];
const _c22 = ["ch-accordion-content", ""];
const _c23 = ["ch-accordion-title", ""];
const _c24 = ["embed"];
const _c25 = ["ch-grid-row", ""];
const _c26 = ["ch-dp-btn", ""];
function DpBtnComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.text);
} }
function DpBtnComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.header);
} }
let TooltipDirective = class TooltipDirective {
    constructor(element) {
        this.element = element;
        this.isInverted = true;
        this.isHtml = false;
        this.position = 'top left';
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.initialize();
    }
    ngOnDestroy() {
        this.destroy();
    }
    get content() {
        return this._content;
    }
    set content(value) {
        this._content = value;
        this.initialize();
    }
    initialize() {
        let data = this.isHtml ? {
            html: `<div>${this.content}</div>`
        } : {
            content: this.content
        };
        $(this.element.nativeElement).popup(Object.assign(data, {
            context: 'body',
            title: this.title,
            position: this.position,
            variation: this.isInverted ? 'inverted' : ''
        }));
    }
    destroy() {
        $(this.element.nativeElement).popup('destroy');
    }
};
TooltipDirective.ɵfac = function TooltipDirective_Factory(t) { return new (t || TooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TooltipDirective, selectors: [["", "ch-tooltip", ""]], inputs: { isInverted: ["is-inverted", "isInverted"], isHtml: ["is-html", "isHtml"], position: "position", content: "content", title: "title" } });
TooltipDirective.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input('title')
], TooltipDirective.prototype, "title", void 0);
__decorate([
    Input('is-inverted')
], TooltipDirective.prototype, "isInverted", void 0);
__decorate([
    Input('is-html')
], TooltipDirective.prototype, "isHtml", void 0);
__decorate([
    Input('position')
], TooltipDirective.prototype, "position", void 0);
__decorate([
    Input('content')
], TooltipDirective.prototype, "content", null);

let SlideDirective = class SlideDirective {
    constructor(element) {
        this.element = element;
    }
    ngOnInit() {
        this.element.nativeElement.classList.add('ui', 'toggle', 'checkbox');
    }
    ngAfterViewInit() {
        $(this.element.nativeElement).checkbox();
    }
};
SlideDirective.ɵfac = function SlideDirective_Factory(t) { return new (t || SlideDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SlideDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SlideDirective, selectors: [["", "ch-slide", ""]] });
SlideDirective.ctorParameters = () => [
    { type: ElementRef }
];

let DropdownSelect = class DropdownSelect {
    constructor(element, ngControl) {
        this.element = element;
        this.ngControl = ngControl;
        this.cleared = false;
        this.isAlive = true;
    }
    ngOnInit() {
        this.element.nativeElement.classList.add('ui', 'search', 'selection', 'dropdown');
        if (this.ngControl) {
            this.ngControl.valueChanges.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
                if (!this.cleared && (!value || (value instanceof Array && value.length == 0))) {
                    setTimeout(() => $(this.element.nativeElement.parentElement).dropdown('clear'));
                    this.cleared = true;
                    return;
                }
                this.cleared = false;
            });
        }
    }
    ngAfterViewInit() {
        this.initialize();
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    initialize() {
        $(this.element.nativeElement).dropdown({
            ignoreCase: true,
            match: 'text',
            fullTextSearch: true
        });
    }
    clear() {
        $(this.element.nativeElement.parentElement).dropdown("clear");
    }
};
DropdownSelect.ɵfac = function DropdownSelect_Factory(t) { return new (t || DropdownSelect)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 2)); };
DropdownSelect.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DropdownSelect, selectors: [["", "ch-dropdown-select", ""]] });
DropdownSelect.ctorParameters = () => [
    { type: ElementRef },
    { type: NgControl, decorators: [{ type: Self }] }
];
DropdownSelect = __decorate([ __param(1, Self())
], DropdownSelect);

let AlertComponent = class AlertComponent {
    constructor() {
        this.modalId = '';
        this.modalId = `alert-${Math.random().toString(36).substring(2)}`;
    }
    ngOnInit() {
    }
    open(alertOptions) {
        this.options = alertOptions;
        this.options.cancelText = this.options.cancelText || 'Cancelar';
        this.options.confirmText = this.options.confirmText || 'OK';
        this.options.confirmBtnColor = this.options.confirmBtnColor || 'green';
        this.options.cancelBtnColor = this.options.cancelBtnColor || 'red';
        $(`#${this.modalId}`).modal({
            closable: false,
        }).modal('show');
    }
    confirm() {
        let fn = (this.options.confirmFn) || (() => { });
        fn();
        this.close();
    }
    cancel() {
        this.options.cancelFn();
        this.close();
    }
    close() {
        $(`#${this.modalId}`).modal('hide');
    }
    get confirmBtnClass() {
        let color = this.options && this.options.confirmBtnColor ? this.options.confirmBtnColor : 'green';
        return `ui ${color} button`;
    }
    get cancelBtnClass() {
        let color = this.options && this.options.cancelBtnColor ? this.options.cancelBtnColor : 'red';
        return `ui ${color} button`;
    }
};
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(); };
AlertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["ch-alert"]], decls: 10, vars: 7, consts: [[1, "ui", "tiny", "modal", 3, "id"], ["class", "header", 4, "ngIf"], [1, "content"], [4, "ngIf", "ngIfElse"], ["htmlMsg", ""], [1, "actions"], [3, "click", 4, "ngIf"], [3, "click"], [1, "header"], [3, "innerHTML"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AlertComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, AlertComponent_div_3_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵtemplate(4, AlertComponent_ng_template_4_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵtemplate(7, AlertComponent_button_7_Template, 2, 2, "button", 6);
        ɵngcc0.ɵɵelementStart(8, "button", 7);
        ɵngcc0.ɵɵlistener("click", function AlertComponent_Template_button_click_8_listener() { return ctx.confirm(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵproperty("id", ctx.modalId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.options == null ? null : ctx.options.headerTitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.options == null ? null : ctx.options.isHtml))("ngIfElse", _r2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.options == null ? null : ctx.options.cancelFn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("class", ctx.confirmBtnClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.options == null ? null : ctx.options.confirmText, " ");
    } }, directives: [ɵngcc2.NgIf], styles: [""] });

let ModalComponent = class ModalComponent {
    constructor() {
        this.showCloseBtn = false;
        // @Input('show-header') showHeader: boolean = true;
        this.size = '';
        this.title = '';
        this.isScrolling = false;
        this.isScrollingImage = false;
        this.allowMultiple = false;
        this.scrollingClass = 'scrolling content';
        this.scrollingImageClass = 'scrolling image content';
        this.defaultClass = 'ui modal';
        this.modalClass = this.defaultClass;
        this.contentClass = '';
        this.modalId = `modal-${Math.random().toString(36).substring(2)}`;
    }
    ngOnInit() {
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.size && simpleChanges.size.currentValue !== simpleChanges.size.previousValue) {
            this.modalClass = `ui ${simpleChanges.size.currentValue} modal`;
        }
    }
    open(opt) {
        opt = opt || {};
        this.title = opt.title || this.title;
        this.modalClass = opt.size ? `ui ${opt.size} modal` : this.modalClass;
        this.contentClass = opt.isScrollingImage != null && opt.isScrollingImage === true
            ? this.scrollingImageClass
            : opt.isScrolling != null && opt.isScrolling === true
                ? this.scrollingClass
                : '';
        this.showCloseBtn = opt.showCloseBtn == null ? this.showCloseBtn : opt.showCloseBtn;
        $(`#${this.modalId}`)
            .modal({
            closable: opt.closable == null ? true : opt.closable,
            allowMultiple: opt.allowMultiple == null ? this.allowMultiple : opt.allowMultiple,
            onHidden: opt.onHidden || (() => { }),
            onShow: opt.onShow || (() => { })
        }).modal('show');
    }
    close() {
        $(`#${this.modalId}`).modal('hide');
    }
};
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(); };
ModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["ch-modal"]], inputs: { showCloseBtn: ["show-close-btn", "showCloseBtn"], size: "size", title: "title", isScrolling: ["is-scrolling", "isScrolling"], isScrollingImage: ["is-scrolling-image", "isScrollingImage"], allowMultiple: ["allow-multiple", "allowMultiple"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 8, vars: 5, consts: [[3, "id"], ["class", "close icon", 4, "ngIf"], [1, "header"], [1, "actions", "actions-modal"], [1, "close", "icon"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ModalComponent_i_1_Template, 1, 0, "i", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div");
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵprojection(7, 1, ["#actions", ""]);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.modalId);
        ɵngcc0.ɵɵattribute("class", ctx.modalClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showCloseBtn);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("class", ctx.contentClass);
    } }, directives: [ɵngcc2.NgIf], styles: [""] });
__decorate([
    Input('show-close-btn')
], ModalComponent.prototype, "showCloseBtn", void 0);
__decorate([
    Input('size')
], ModalComponent.prototype, "size", void 0);
__decorate([
    Input('title')
], ModalComponent.prototype, "title", void 0);
__decorate([
    Input('is-scrolling')
], ModalComponent.prototype, "isScrolling", void 0);
__decorate([
    Input('is-scrolling-image')
], ModalComponent.prototype, "isScrollingImage", void 0);
__decorate([
    Input('allow-multiple')
], ModalComponent.prototype, "allowMultiple", void 0);

let SideBarLinkComponent = class SideBarLinkComponent {
    constructor() {
        this.route = [];
        this.icon = '';
        this.description = '';
        this.exactLink = false;
        this.hasChildren = false;
    }
    ngOnInit() {
    }
};
SideBarLinkComponent.ɵfac = function SideBarLinkComponent_Factory(t) { return new (t || SideBarLinkComponent)(); };
SideBarLinkComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideBarLinkComponent, selectors: [["ch-side-bar-link"]], inputs: { route: "route", icon: "icon", description: "description", exactLink: ["exact-link", "exactLink"], hasChildren: ["has-children", "hasChildren"] }, ngContentSelectors: _c3, decls: 3, vars: 2, consts: [["class", "ch-menu-item ch-dropdown", 4, "ngIf", "ngIfElse"], ["noChildrenTemp", ""], [1, "ch-menu-item", "ch-dropdown"], [1, "ch-dropdown-button", 3, "href"], [1, "ch-menu-item-label"], [1, "fal", "fa-chevron-right", "fa-icon", "dropdown"], [1, "ch-dropdown-content"], [1, "ch-dropdown-menu"], ["routerLinkActive", "active", 1, "ch-menu-item", 3, "routerLinkActiveOptions"], [3, "routerLink"]], template: function SideBarLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, SideBarLinkComponent_li_0_Template, 9, 2, "li", 0);
        ɵngcc0.ɵɵtemplate(1, SideBarLinkComponent_ng_template_1_Template, 5, 6, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasChildren)("ngIfElse", _r1);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.RouterLinkActive, ɵngcc3.RouterLinkWithHref], styles: [".ch-dropdown-button[_ngcontent-%COMP%]{cursor:pointer}"] });
__decorate([
    Input('route')
], SideBarLinkComponent.prototype, "route", void 0);
__decorate([
    Input('icon')
], SideBarLinkComponent.prototype, "icon", void 0);
__decorate([
    Input('description')
], SideBarLinkComponent.prototype, "description", void 0);
__decorate([
    Input('exact-link')
], SideBarLinkComponent.prototype, "exactLink", void 0);
__decorate([
    Input('has-children')
], SideBarLinkComponent.prototype, "hasChildren", void 0);

let SideBarComponent = class SideBarComponent {
    constructor(elementRef, cdref) {
        this.elementRef = elementRef;
        this.cdref = cdref;
        this.collapsedKey = 'ch-nav-state';
        this.collapsed = false;
        this.isCollapsed = false;
        this.appName = '';
        this.appUrl = '';
        this._logoUrl = '';
        this.expandButtonData = {
            text: '',
            color: 'red',
            icon: ''
        };
    }
    ngOnInit() {
        let collapsed = localStorage.getItem(this.collapsedKey);
        if (collapsed)
            this.collapsed = JSON.parse(collapsed);
        this.isCollapsed = this.collapsed;
        this.elementRef.nativeElement.classList.add('ch-nav');
        if (this.collapsed == true)
            this.elementRef.nativeElement.classList.add('collapsed');
    }
    ngAfterViewInit() {
        this.changes = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                const classList = mutation.target.classList;
                if (classList.contains('collapsed') && classList.contains('hover')) {
                    this.isCollapsed = false;
                    return;
                }
                if (classList.contains('collapsed')) {
                    this.isCollapsed = true;
                    return;
                }
                this.isCollapsed = false;
            });
        });
        this.changes.observe(this.elementRef.nativeElement, {
            attributes: true,
            childList: true,
            characterData: true
        });
    }
    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }
    get logoOptions() {
        return this._logoOptions;
    }
    set logoOptions(value) {
        let defaultLogo = value && value.default
            ? value.default
            : {
                url: null,
                height: 36,
                width: 36
            };
        defaultLogo = Object.assign(Object.assign({}, defaultLogo), { url: defaultLogo.url || null, height: defaultLogo.height || 36, width: defaultLogo.width || 36 });
        let brandLogo = value && value.brand
            ? value.brand
            : {
                url: null,
                height: 36,
                width: 36
            };
        brandLogo = Object.assign(Object.assign({}, brandLogo), { url: brandLogo.url || null, height: brandLogo.height || 36, width: brandLogo.width || 36 });
        value = value || {
            default: defaultLogo,
            brand: brandLogo
        };
        this._logoOptions = Object.assign(Object.assign({}, value), { default: value.default });
    }
    set logoUrl(value) {
        this._logoUrl = value;
    }
    get logoUrl() {
        return this._logoUrl;
    }
    get logo() {
        var _a, _b;
        return this.isCollapsed ? (_a = this.logoOptions) === null || _a === void 0 ? void 0 : _a.brand : (_b = this.logoOptions) === null || _b === void 0 ? void 0 : _b.default;
    }
    changeState() {
        this.collapsed = !this.collapsed;
        localStorage.setItem(this.collapsedKey, JSON.stringify(this.collapsed));
    }
    get expandButtonIconClass() {
        return `${this.expandButtonData.icon} fa-icon text ${this.expandButtonData.color}`;
    }
    get expandButtonTextClass() {
        return `ch-menu-item-label text  ${this.expandButtonData.color}`;
    }
};
SideBarComponent.ɵfac = function SideBarComponent_Factory(t) { return new (t || SideBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SideBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideBarComponent, selectors: [["", "ch-side-bar", ""]], inputs: { appName: ["app-name", "appName"], appUrl: ["app-url", "appUrl"], expandButtonData: ["expand-button-data", "expandButtonData"], logoOptions: ["logo-options", "logoOptions"], logoUrl: ["logo-url", "logoUrl"] }, attrs: _c4, ngContentSelectors: _c3, decls: 17, vars: 12, consts: [[1, "ch-logo"], [1, "ch-logo-icon", 3, "ngStyle"], [3, "ngStyle", "src"], [1, "app-url", 3, "href"], ["class", "ch-logo-label", 4, "ngIf"], [1, "ch-expand-button"], ["class", "ch-menu", 4, "ngIf"], ["data-expand", "Expandir", "data-minimize", "Minimizar", 3, "click"], ["width", "20px", "height", "15px", "viewBox", "0 0 20 15", 1, "icon", "minimize"], ["stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["id", "minimize", "fill", "#000000", "fill-rule", "nonzero"], ["d", "M1.4,2.22044605e-16 L18.6,2.22044605e-16 C19.3731986,8.0010317e-17 20,0.62680135 20,1.4 L20,13.6 C20,14.3731986 19.3731986,15 18.6,15 L1.4,15 C0.62680135,15 5.38778735e-16,14.3731986 4.4408921e-16,13.6 L0,1.4 C-9.46895252e-17,0.62680135 0.62680135,1.42034288e-16 1.4,2.22044605e-16 Z M18.3,1 L9,1 L9,14 L18.3,14 C18.6865993,14 19,13.6865993 19,13.3 L19,1.7 C19,1.31340068 18.6865993,1 18.3,1 Z M6.28125,11.375 L6.5,11.15625 C6.58333375,11.0937497 6.625,11.0104172 6.625,10.90625 C6.625,10.8020828 6.58333375,10.7083337 6.5,10.625 L3.875,8.03125 L9,8.03125 L9,6.96875 L3.875,6.96875 L6.5,4.375 C6.58333375,4.29166625 6.625,4.19791719 6.625,4.09375 C6.625,3.98958281 6.58333375,3.90625031 6.5,3.84375 L6.28125,3.625 C6.19791625,3.54166625 6.10937547,3.5 6.015625,3.5 C5.92187453,3.5 5.83333375,3.54166625 5.75,3.625 L2.125,7.25 C2.04166625,7.31250031 2,7.39583281 2,7.5 C2,7.60416719 2.04166625,7.68749969 2.125,7.75 L5.75,11.375 C5.83333375,11.4583337 5.92187453,11.5 6.015625,11.5 C6.10937547,11.5 6.19791625,11.4583337 6.28125,11.375 Z", "id", "path-1"], ["width", "20px", "height", "15px", "viewBox", "0 0 20 15", 1, "icon", "expand"], ["id", "expand", "fill", "#000000", "fill-rule", "nonzero"], ["d", "M1.4,2.22044605e-16 L18.6,2.22044605e-16 C19.3731986,8.0010317e-17 20,0.62680135 20,1.4 L20,13.6 C20,14.3731986 19.3731986,15 18.6,15 L1.4,15 C0.62680135,15 5.38778735e-16,14.3731986 4.4408921e-16,13.6 L0,1.4 C-9.46895252e-17,0.62680135 0.62680135,1.42034288e-16 1.4,2.22044605e-16 Z M18.3,1 L4,1 L4,14 L18.3,14 C18.6865993,14 19,13.6865993 19,13.3 L19,1.7 C19,1.31340068 18.6865993,1 18.3,1 Z M6.71875,11.375 L6.5,11.15625 C6.41666625,11.0937497 6.375,11.0104172 6.375,10.90625 C6.375,10.8020828 6.41666625,10.7083337 6.5,10.625 L9.125,8.03125 L4,8.03125 L4,6.96875 L9.125,6.96875 L6.5,4.375 C6.41666625,4.29166625 6.375,4.19791719 6.375,4.09375 C6.375,3.98958281 6.41666625,3.90625031 6.5,3.84375 L6.71875,3.625 C6.80208375,3.54166625 6.89062453,3.5 6.984375,3.5 C7.07812547,3.5 7.16666625,3.54166625 7.25,3.625 L10.875,7.25 C10.9583337,7.31250031 11,7.39583281 11,7.5 C11,7.60416719 10.9583337,7.68749969 10.875,7.75 L7.25,11.375 C7.16666625,11.4583337 7.07812547,11.5 6.984375,11.5 C6.89062453,11.5 6.80208375,11.4583337 6.71875,11.375 Z", "id", "path-1"], [1, "ch-logo-label"], [1, "ch-menu"], [1, "ch-menu-item"], [3, "href"]], template: function SideBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵtemplate(4, SideBarComponent_span_4_Template, 2, 1, "span", 4);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵtemplate(7, SideBarComponent_ul_7_Template, 7, 3, "ul", 6);
        ɵngcc0.ɵɵelementStart(8, "button", 7);
        ɵngcc0.ɵɵlistener("click", function SideBarComponent_Template_button_click_8_listener() { return ctx.changeState(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(9, "svg", 8)(10, "g", 9)(11, "g", 10);
        ɵngcc0.ɵɵelement(12, "path", 11);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(13, "svg", 12)(14, "g", 9)(15, "g", 13);
        ɵngcc0.ɵɵelement(16, "path", 14);
        ɵngcc0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(6, _c5, (ctx.logo == null ? null : ctx.logo.width) + "px", (ctx.logo == null ? null : ctx.logo.height) + "px"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(9, _c6, (ctx.logo == null ? null : ctx.logo.width) + "px", (ctx.logo == null ? null : ctx.logo.height) + "px"))("src", (ctx.logo == null ? null : ctx.logo.url) || ctx.logoUrl || "", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("href", ctx.appUrl || "", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.appName);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.expandButtonData.text);
    } }, directives: [ɵngcc2.NgStyle, ɵngcc2.NgIf], styles: ["a.app-url[_ngcontent-%COMP%], a.app-url[_ngcontent-%COMP%]:active, a.app-url[_ngcontent-%COMP%]:hover, a.app-url[_ngcontent-%COMP%]:visited{text-decoration:none;color:#fff!important}.text.white[_ngcontent-%COMP%]{color:#fff}.text.grey[_ngcontent-%COMP%]{color:#ccc}.text.black[_ngcontent-%COMP%]{color:#1b1c1d}.text.yellow[_ngcontent-%COMP%]{color:#f2c61f}.text.teal[_ngcontent-%COMP%]{color:#00b5ad}.text.red[_ngcontent-%COMP%]{color:#d95c5c}.text.purple[_ngcontent-%COMP%]{color:#564f8a}.text.pink[_ngcontent-%COMP%]{color:#d9499a}.text.orange[_ngcontent-%COMP%]{color:#e07b53}.text.green[_ngcontent-%COMP%]{color:#5bbd72}.text.blue[_ngcontent-%COMP%]{color:#3b83c0}"] });
SideBarComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
__decorate([
    Input('app-name')
], SideBarComponent.prototype, "appName", void 0);
__decorate([
    Input('app-url')
], SideBarComponent.prototype, "appUrl", void 0);
__decorate([
    Input('logo-options')
], SideBarComponent.prototype, "logoOptions", null);
__decorate([
    Input('logo-url')
], SideBarComponent.prototype, "logoUrl", null);
__decorate([
    Input('expand-button-data')
], SideBarComponent.prototype, "expandButtonData", void 0);

let SideBarMenuComponent = class SideBarMenuComponent {
    constructor() { }
    ngOnInit() {
    }
};
SideBarMenuComponent.ɵfac = function SideBarMenuComponent_Factory(t) { return new (t || SideBarMenuComponent)(); };
SideBarMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideBarMenuComponent, selectors: [["ch-side-bar-menu"]], ngContentSelectors: _c3, decls: 5, vars: 0, consts: [[1, "ch-menu"], [1, "ch-menu-item", "more", "mobile-only"], ["data-toogle", "nav"], [1, "fal", "fa-ellipsis-h-alt", "fa-icon"]], template: function SideBarMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "li", 1)(3, "button", 2);
        ɵngcc0.ɵɵelement(4, "i", 3);
        ɵngcc0.ɵɵelementEnd()()();
    } }, styles: [""] });

let TopBarComponent = class TopBarComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        this.elementRef.nativeElement.className = 'ch-header';
    }
};
TopBarComponent.ɵfac = function TopBarComponent_Factory(t) { return new (t || TopBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TopBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TopBarComponent, selectors: [["", "ch-top-bar", ""]], attrs: _c7, ngContentSelectors: _c3, decls: 2, vars: 0, consts: [["ch-top-bar-breadcrumb", ""]], template: function TopBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
    } }, directives: function () { return [TopBarBreadcrumbComponent]; }, styles: [""] });
TopBarComponent.ctorParameters = () => [
    { type: ElementRef }
];

let TopBarBreadcrumbService = class TopBarBreadcrumbService {
    constructor() {
        this.emmiter = new EventEmitter();
    }
};
TopBarBreadcrumbService.ɵfac = function TopBarBreadcrumbService_Factory(t) { return new (t || TopBarBreadcrumbService)(); };
TopBarBreadcrumbService.ɵprov = ɵɵdefineInjectable({ factory: function TopBarBreadcrumbService_Factory() { return new TopBarBreadcrumbService(); }, token: TopBarBreadcrumbService, providedIn: "root" });

let TopBarBreadcrumbComponent = class TopBarBreadcrumbComponent {
    constructor(elementRef, service) {
        this.elementRef = elementRef;
        this.service = service;
        this.isAlive = true;
        this.paths = [];
        this.service.emmiter.subscribe((options) => {
            options = options || {
                icon: null,
                path: null,
                title: null,
                paths: []
            };
            this.icon = options.icon || '';
            this.title = options.title || '';
            this.paths = options.paths || [];
            this.path = this.handlePath(options.path);
        });
    }
    ngOnInit() {
        this.elementRef.nativeElement.className = 'ch-breadcrumb';
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    handlePath(path) {
        if (!path) {
            return '';
        }
        if (path.length === 0) {
            return '';
        }
        return path.join(' / ');
    }
};
TopBarBreadcrumbComponent.ɵfac = function TopBarBreadcrumbComponent_Factory(t) { return new (t || TopBarBreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(TopBarBreadcrumbService)); };
TopBarBreadcrumbComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TopBarBreadcrumbComponent, selectors: [["", "ch-top-bar-breadcrumb", ""]], attrs: _c8, decls: 4, vars: 2, consts: [[4, "ngIf"], ["tplItem", ""], [1, "ch-breadcrumb-section", "active"], [3, "href", "title"], ["class", "ch-breadcrumb-section", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "ch-breadcrumb-section", 3, "ngClass"], [3, "title", "routerLink", "queryParams", 4, "ngIf", "ngIfElse"], ["noNavigation", ""], [3, "title", "routerLink", "queryParams"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "title", "href"], ["class", "m-r-10 m-l-5", 4, "ngIf"], [1, "m-r-10", "m-l-5"]], template: function TopBarBreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TopBarBreadcrumbComponent_ng_container_0_Template, 5, 3, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TopBarBreadcrumbComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, TopBarBreadcrumbComponent_ng_template_2_Template, 4, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.paths.length === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.paths.length > 0);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc2.NgClass, ɵngcc3.RouterLinkWithHref, ɵngcc2.NgTemplateOutlet], styles: [".path-selector[_ngcontent-%COMP%]{cursor:pointer I!important}"] });
TopBarBreadcrumbComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: TopBarBreadcrumbService }
];

let TopBarMenuComponent = class TopBarMenuComponent {
    constructor() { }
    ngOnInit() {
    }
};
TopBarMenuComponent.ɵfac = function TopBarMenuComponent_Factory(t) { return new (t || TopBarMenuComponent)(); };
TopBarMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TopBarMenuComponent, selectors: [["ch-top-bar-menu"]], ngContentSelectors: _c3, decls: 2, vars: 0, consts: [[1, "ch-header-nav", "animated"]], template: function TopBarMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });

let SearchFormComponent = class SearchFormComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.title = 'Formulário de pesquisa';
        this.clearBtnText = 'Limpar';
        this.searchBtnText = 'Pesquisar';
        this.hiddenSearchBtnTooltip = 'Mostrar campos de pesquisa';
        this.visibleSearchBtnTooltip = 'Ocultar campos de pesquisa';
        this.updateBtnTooltip = 'Atualizar';
        this.loading = false;
        this.tootipIsInverted = true;
        this.tootipIsInvertedPosition = 'top left';
        this.withTooltip = false;
        this.color = 'blue';
        this.hidden = true;
        this.onClear = new EventEmitter();
        this.onSearch = new EventEmitter();
        this.onChange = new EventEmitter();
        this.searchBtnPosition = 'left';
        this.clear = () => this.onClear.emit();
        this.search = () => this.onSearch.emit();
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.searchBtnPosition && changes.searchBtnPosition.currentValue) {
            this.searchBtnPosition = changes.searchBtnPosition.currentValue;
        }
    }
    toggle(event) {
        this.hidden = !this.hidden;
        this.onChange.emit({
            originalEvent: event,
            hidden: this.hidden
        });
    }
    get defaultSearchBtnPosition() {
        return this.searchBtnPosition === 'right' ? 'float-right' : 'float-left';
    }
    get extraBtnPosition() {
        switch (this.searchBtnPosition) {
            case 'left':
                return 'float-right';
            case 'right':
                return 'float-left';
            default:
                return 'float-right';
        }
    }
};
SearchFormComponent.ɵfac = function SearchFormComponent_Factory(t) { return new (t || SearchFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SearchFormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SearchFormComponent, selectors: [["", "ch-search-form", ""]], inputs: { title: "title", clearBtnText: "clearBtnText", searchBtnText: "searchBtnText", hiddenSearchBtnTooltip: "hiddenSearchBtnTooltip", visibleSearchBtnTooltip: "visibleSearchBtnTooltip", updateBtnTooltip: "updateBtnTooltip", loading: "loading", tootipIsInverted: "tootipIsInverted", tootipIsInvertedPosition: "tootipIsInvertedPosition", withTooltip: ["with-tooltip", "withTooltip"], color: "color", hidden: ["is-hidden", "hidden"], searchBtnPosition: "searchBtnPosition" }, outputs: { onClear: "on-clear", onSearch: "on-search", onChange: "onChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c12, ngContentSelectors: _c16, decls: 18, vars: 7, consts: [[4, "ngIf", "ngIfElse"], ["withoutTooltipTem", ""], [1, "clear-fix"], [3, "hidden"], [1, "ui", "form"], [1, "ui", "dividing", "header"], [1, "ui", "orange", "basic", "button", 3, "click"], [1, "fas", "fa-eraser", "fa-icon"], [3, "click"], [1, "fas", "fa-search", "fa-icon"], ["ch-tooltip", "", 3, "ngClass", "content", "is-inverted", "position", "is-html", "click"], [1, "fas", "fa-filter"], ["ch-tooltip", "", 3, "ngClass", "content", "is-inverted", "is-html", "position", "click"], [1, "fas", "fa-sync"], [3, "ngClass", "click"]], template: function SearchFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c15);
        ɵngcc0.ɵɵtemplate(0, SearchFormComponent_ng_container_0_Template, 6, 17, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, SearchFormComponent_ng_template_1_Template, 5, 9, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "div", 2);
        ɵngcc0.ɵɵelementStart(6, "ch-transiction-fade", 3)(7, "div", 4);
        ɵngcc0.ɵɵelement(8, "h4", 5);
        ɵngcc0.ɵɵprojection(9, 1);
        ɵngcc0.ɵɵelementStart(10, "div")(11, "button", 6);
        ɵngcc0.ɵɵlistener("click", function SearchFormComponent_Template_button_click_11_listener() { return ctx.clear(); });
        ɵngcc0.ɵɵelement(12, "i", 7);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "button", 8);
        ɵngcc0.ɵɵlistener("click", function SearchFormComponent_Template_button_click_14_listener() { return ctx.search(); });
        ɵngcc0.ɵɵelement(15, "i", 9);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(17, "h4", 5);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.withTooltip)("ngIfElse", _r1);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("class", ctx.extraBtnPosition);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.hidden);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.clearBtnText, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("class", "ui " + ctx.color + " basic button");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.searchBtnText, " ");
    } }, directives: function () { return [ɵngcc2.NgIf, TooltipDirective, ɵngcc2.NgClass, TransictionFadeComponent]; }, styles: [".float-left[_ngcontent-%COMP%]{float:left;margin-left:auto}.float-right[_ngcontent-%COMP%]{float:right;margin-right:auto}.clear-fix[_ngcontent-%COMP%]{clear:both}"] });
SearchFormComponent.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input('title')
], SearchFormComponent.prototype, "title", void 0);
__decorate([
    Input('clearBtnText')
], SearchFormComponent.prototype, "clearBtnText", void 0);
__decorate([
    Input('searchBtnText')
], SearchFormComponent.prototype, "searchBtnText", void 0);
__decorate([
    Input('hiddenSearchBtnTooltip')
], SearchFormComponent.prototype, "hiddenSearchBtnTooltip", void 0);
__decorate([
    Input('visibleSearchBtnTooltip')
], SearchFormComponent.prototype, "visibleSearchBtnTooltip", void 0);
__decorate([
    Input('updateBtnTooltip')
], SearchFormComponent.prototype, "updateBtnTooltip", void 0);
__decorate([
    Input('loading')
], SearchFormComponent.prototype, "loading", void 0);
__decorate([
    Input('tootipIsInverted')
], SearchFormComponent.prototype, "tootipIsInverted", void 0);
__decorate([
    Input('tootipIsInvertedPosition')
], SearchFormComponent.prototype, "tootipIsInvertedPosition", void 0);
__decorate([
    Input('with-tooltip')
], SearchFormComponent.prototype, "withTooltip", void 0);
__decorate([
    Input('color')
], SearchFormComponent.prototype, "color", void 0);
__decorate([
    Input('is-hidden')
], SearchFormComponent.prototype, "hidden", void 0);
__decorate([
    Output('on-clear')
], SearchFormComponent.prototype, "onClear", void 0);
__decorate([
    Output('on-search')
], SearchFormComponent.prototype, "onSearch", void 0);
__decorate([
    Output()
], SearchFormComponent.prototype, "onChange", void 0);
__decorate([
    Input('searchBtnPosition')
], SearchFormComponent.prototype, "searchBtnPosition", void 0);

let IdGeneratorService = class IdGeneratorService {
    constructor() {
        this.get = () => `${Math.random().toString(36).substring(2)}`;
    }
};
IdGeneratorService.ɵfac = function IdGeneratorService_Factory(t) { return new (t || IdGeneratorService)(); };
IdGeneratorService.ɵprov = ɵɵdefineInjectable({ factory: function IdGeneratorService_Factory() { return new IdGeneratorService(); }, token: IdGeneratorService, providedIn: "root" });

class NumberValues {
    static getDescription(value) {
        let entry = this.All.find(x => x.value === value);
        return entry ? entry.descrition : null;
    }
}
NumberValues.All = [
    {
        value: 1,
        descrition: 'one'
    },
    {
        value: 2,
        descrition: 'two'
    },
    {
        value: 3,
        descrition: 'three'
    },
    {
        value: 4,
        descrition: 'four'
    },
    {
        value: 5,
        descrition: 'five'
    },
    {
        value: 6,
        descrition: 'six'
    },
    {
        value: 7,
        descrition: 'seven'
    },
    {
        value: 8,
        descrition: 'eight'
    },
    {
        value: 9,
        descrition: 'nine'
    },
    {
        value: 10,
        descrition: 'ten'
    },
    {
        value: 11,
        descrition: 'eleven'
    },
    {
        value: 12,
        descrition: 'twelve'
    },
    {
        value: 13,
        descrition: 'thirteen'
    },
    {
        value: 14,
        descrition: 'fourteen'
    },
    {
        value: 15,
        descrition: 'fifteen'
    },
    {
        value: 16,
        descrition: 'sixteen'
    }
];

let TopBarLoaderServiceService = class TopBarLoaderServiceService {
    constructor() {
        this.show = (selector = '.ch-loader-progress') => document.querySelector(selector).classList.add('is-active');
        this.hide = (selector = '.ch-loader-progress') => setTimeout(() => document.querySelector(selector).classList.remove('is-active'), 500);
    }
};
TopBarLoaderServiceService.ɵfac = function TopBarLoaderServiceService_Factory(t) { return new (t || TopBarLoaderServiceService)(); };
TopBarLoaderServiceService.ɵprov = ɵɵdefineInjectable({ factory: function TopBarLoaderServiceService_Factory() { return new TopBarLoaderServiceService(); }, token: TopBarLoaderServiceService, providedIn: "root" });

let GridColumnComponent = class GridColumnComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.tablet = 16;
        this.computer = 16;
        this.centered = false;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.elementRef.nativeElement.className = this.classValue;
    }
    get classValue() {
        let tablet = Number.parseFloat(this.tablet);
        let computer = Number.parseFloat(this.computer);
        return `${NumberValues.getDescription(computer) || NumberValues.getDescription(16)} wide computer ${NumberValues.getDescription(tablet) || NumberValues.getDescription(16)} wide tablet column${this.centered ? ' centered' : ''}`;
    }
};
GridColumnComponent.ɵfac = function GridColumnComponent_Factory(t) { return new (t || GridColumnComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
GridColumnComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GridColumnComponent, selectors: [["", "ch-grid-column", ""]], inputs: { tablet: "tablet", computer: "computer", centered: "centered" }, attrs: _c17, ngContentSelectors: _c3, decls: 1, vars: 0, template: function GridColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [""] });
GridColumnComponent.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input('tablet')
], GridColumnComponent.prototype, "tablet", void 0);
__decorate([
    Input('computer')
], GridColumnComponent.prototype, "computer", void 0);
__decorate([
    Input('centered')
], GridColumnComponent.prototype, "centered", void 0);

let HDividerComponent = class HDividerComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        this.elementRef.nativeElement.classList.add('ui', 'dividing', 'header');
    }
};
HDividerComponent.ɵfac = function HDividerComponent_Factory(t) { return new (t || HDividerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
HDividerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HDividerComponent, selectors: [["", "ch-hdivider", ""], ["", "ch-divider", ""]], attrs: _c18, decls: 0, vars: 0, template: function HDividerComponent_Template(rf, ctx) { }, styles: [""] });
HDividerComponent.ctorParameters = () => [
    { type: ElementRef }
];

var FadeDirection;
(function (FadeDirection) {
    FadeDirection["upDown"] = "up down";
    FadeDirection["down_up"] = "down up";
    FadeDirection["leftRight"] = "left right";
    FadeDirection["rightLeft"] = "right left";
})(FadeDirection || (FadeDirection = {}));

let TransictionFadeComponent = class TransictionFadeComponent {
    constructor() {
        this.id = `${Math.random().toString(36).substring(2)}`;
        this._hidden = true;
        this._direction = FadeDirection.upDown;
    }
    ngOnInit() {
    }
    set hidden(value) {
        this._hidden = value;
        this.showHide();
    }
    get hidden() {
        return this._hidden;
    }
    set direction(value) {
        this._direction = value;
    }
    get direction() {
        return this._direction;
    }
    showHide() {
        $(`#${this.id}`).transition(this.handleDirection());
    }
    handleDirection() {
        let values = this.direction.split(' ').map(x => `fade ${x}`);
        return this.hidden ? values[0] : values[1];
    }
};
TransictionFadeComponent.ɵfac = function TransictionFadeComponent_Factory(t) { return new (t || TransictionFadeComponent)(); };
TransictionFadeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TransictionFadeComponent, selectors: [["ch-transiction-fade"]], inputs: { hidden: "hidden", direction: "direction" }, ngContentSelectors: _c3, decls: 2, vars: 4, consts: [[1, "ui", "transition", 3, "id", "ngClass"]], template: function TransictionFadeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c19, ctx.hidden));
    } }, directives: [ɵngcc2.NgClass], styles: [""] });
__decorate([
    Input('hidden')
], TransictionFadeComponent.prototype, "hidden", null);
__decorate([
    Input('direction')
], TransictionFadeComponent.prototype, "direction", null);

let DialogComponent = class DialogComponent {
    constructor(idService) {
        this.idService = idService;
        this.defaultDuration = '300';
        this.titleIsHtml = false;
        this.closeOnClick = true;
        this.width = '400px';
        this.ids = {
            overlay: `${this.idService.get()}-overlay`,
            dialog: `${this.idService.get()}-dialog`,
            dialogContainer: `${this.idService.get()}-dialog-container`
        };
    }
    get domOverlay() {
        return document.getElementById(this.ids.overlay);
    }
    get domDialogContainer() {
        return document.getElementById(this.ids.dialogContainer);
    }
    get duration() {
        return this.defaultDuration;
    }
    get effectDuration() {
        return Number.parseInt(this.duration, 0);
    }
    set duration(value) {
        this.defaultDuration = value;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        $(this.idDialog).on('click', (e) => {
            this.closeEvent(e);
            e.stopPropagation();
        });
        $(this.idOverlay).on('click', (e) => {
            this.closeEvent(e);
            e.stopPropagation();
        });
        $(this.idDialogContainer).on('click', (e) => {
            this.closeEvent(e);
            e.stopPropagation();
        });
        $(this.idDialog).on('keydown', (e) => {
            $.keyboardClose(e, close);
        });
        // if (this.domOverlay) {
        //   (this.domOverlay as HTMLElement).removeEventListener('click', (e) => this.closeEvent(e), false);
        // }
    }
    ngOnDestroy() {
        // if (this.domOverlay) {
        //   (this.domOverlay as HTMLElement).removeEventListener('click', (e) => this.closeEvent(e), false);
        // }
    }
    get idOverlay() {
        return `#${this.ids.overlay}`;
    }
    get idDialog() {
        return `#${this.ids.dialog}`;
    }
    get idDialogContainer() {
        return `#${this.ids.dialogContainer}`;
    }
    open() {
        $(this.idDialog).show(this.effectDuration);
        $(this.idDialog).focus();
        $(this.idDialogContainer).addClass('active');
    }
    close() {
        $(this.idDialogContainer).removeClass('active');
        $(this.idDialog).hide(this.effectDuration);
        if (this.onClose) {
            this.onClose();
        }
    }
    closeEvent(e) {
        if (this.closeOnClick === true) {
            this.close();
            return;
        }
        // console.log(this.ids.overlay, e.target.id);
        // if (this.closeOnClick === false && e !== null && e.target.id === this.ids.overlay) {
        //   console.log('close 2', e.target.id);
        //   this.close();
        //   return;
        // }
    }
};
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(ɵngcc0.ɵɵdirectiveInject(IdGeneratorService)); };
DialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["ch-dialog"]], inputs: { titleIsHtml: ["title-is-html", "titleIsHtml"], closeOnClick: ["close-on-click", "closeOnClick"], width: "width", duration: "duration", title: "title", onClose: ["on-close", "onClose"] }, ngContentSelectors: _c3, decls: 11, vars: 7, consts: [["tabindex", "0", 1, "ch-dialog", 3, "id"], [1, "ch-overlay", 3, "id"], [1, "ch-dialog-container", 3, "id", "ngStyle"], [1, "ch-dialog-header"], [1, "content"], ["class", "title", 4, "ngIf"], [1, "actions"], [1, "button", 3, "href", "click"], [1, "close", "icon"], [1, "ch-dialog-content"], [1, "title"], [3, "innerHTML", 4, "ngIf", "ngIfElse"], ["elseTitle", ""], [3, "innerHTML"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, DialogComponent_div_5_Template, 4, 2, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6)(7, "a", 7);
        ɵngcc0.ɵɵlistener("click", function DialogComponent_Template_a_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelement(8, "i", 8);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(9, "div", 9);
        ɵngcc0.ɵɵprojection(10);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.ids.dialog);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.ids.overlay);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("id", ctx.ids.dialogContainer)("ngStyle", ɵngcc0.ɵɵpureFunction1(5, _c20, ctx.width));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
    } }, directives: [ɵngcc2.NgStyle, ɵngcc2.NgIf], styles: ["i.close.icon[_ngcontent-%COMP%]{cursor:pointer}"] });
DialogComponent.ctorParameters = () => [
    { type: IdGeneratorService }
];
__decorate([
    Input('duration')
], DialogComponent.prototype, "duration", null);
__decorate([
    Input('title')
], DialogComponent.prototype, "title", void 0);
__decorate([
    Input('title-is-html')
], DialogComponent.prototype, "titleIsHtml", void 0);
__decorate([
    Input('close-on-click')
], DialogComponent.prototype, "closeOnClick", void 0);
__decorate([
    Input('width')
], DialogComponent.prototype, "width", void 0);
__decorate([
    Input('on-close')
], DialogComponent.prototype, "onClose", void 0);

let PointingLabelComponent = class PointingLabelComponent {
    constructor() {
        this.color = 'red';
        this.cssClass = `ui pointing ${this.color} basic label`;
    }
    ngOnInit() {
    }
    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
        switch (value) {
            case 'top':
                this.cssClass = `ui pointing below ${this.color} basic label`;
                break;
            case 'left':
                this.cssClass = `ui left pointing ${this.color} basic label`;
                break;
            case 'right':
                this.cssClass = `ui right pointing ${this.color} basic label`;
                break;
            default:
                this.cssClass = `ui pointing ${this.color} basic label`;
        }
    }
};
PointingLabelComponent.ɵfac = function PointingLabelComponent_Factory(t) { return new (t || PointingLabelComponent)(); };
PointingLabelComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PointingLabelComponent, selectors: [["ch-pointing-label"]], inputs: { color: "color", position: "position" }, ngContentSelectors: _c3, decls: 2, vars: 1, template: function PointingLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.cssClass);
    } }, styles: [""] });
__decorate([
    Input('color')
], PointingLabelComponent.prototype, "color", void 0);
__decorate([
    Input('position')
], PointingLabelComponent.prototype, "position", null);

let AccordionComponent = class AccordionComponent {
    constructor(element) {
        this.element = element;
        element.nativeElement.classList.add('ui', 'styled', 'fluid', 'accordion');
    }
    ngOnInit() {
        $(this.element.nativeElement).accordion();
    }
    ngAfterViewInit() {
        $(this.element.nativeElement).accordion();
    }
};
AccordionComponent.ɵfac = function AccordionComponent_Factory(t) { return new (t || AccordionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AccordionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccordionComponent, selectors: [["", "ch-accordion", ""]], attrs: _c21, ngContentSelectors: _c3, decls: 1, vars: 0, template: function AccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [""] });
AccordionComponent.ctorParameters = () => [
    { type: ElementRef }
];

let AccordionContentComponent = class AccordionContentComponent {
    constructor(element) {
        this.element = element;
        element.nativeElement.classList.add('content');
    }
    ngOnInit() {
    }
};
AccordionContentComponent.ɵfac = function AccordionContentComponent_Factory(t) { return new (t || AccordionContentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AccordionContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccordionContentComponent, selectors: [["", "ch-accordion-content", ""]], attrs: _c22, ngContentSelectors: _c3, decls: 1, vars: 0, template: function AccordionContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [""] });
AccordionContentComponent.ctorParameters = () => [
    { type: ElementRef }
];

let AccordionTitleComponent = class AccordionTitleComponent {
    constructor(element) {
        this.element = element;
        element.nativeElement.classList.add('title');
    }
    ngOnInit() {
    }
};
AccordionTitleComponent.ɵfac = function AccordionTitleComponent_Factory(t) { return new (t || AccordionTitleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AccordionTitleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccordionTitleComponent, selectors: [["", "ch-accordion-title", ""]], attrs: _c23, ngContentSelectors: _c3, decls: 2, vars: 0, consts: [[1, "dropdown", "icon"]], template: function AccordionTitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "i", 0);
        ɵngcc0.ɵɵprojection(1);
    } }, styles: [""] });
AccordionTitleComponent.ctorParameters = () => [
    { type: ElementRef }
];

let EmbedComponent = class EmbedComponent {
    constructor() { }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.initialize();
    }
    get url() {
        return this._url;
    }
    set url(value) {
        this._url = value;
        this.initialize();
    }
    initialize() {
        if (!this.url)
            return;
        this.embed.nativeElement.setAttribute('data-url', this.url);
        $(this.embed.nativeElement).embed();
    }
};
EmbedComponent.ɵfac = function EmbedComponent_Factory(t) { return new (t || EmbedComponent)(); };
EmbedComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EmbedComponent, selectors: [["ch-embed"]], viewQuery: function EmbedComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c24, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.embed = _t.first);
    } }, inputs: { url: "url" }, decls: 2, vars: 0, consts: [[1, "ui", "embed"], ["embed", ""]], template: function EmbedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
    } }, styles: [""] });
__decorate([
    Input('url')
], EmbedComponent.prototype, "url", null);
__decorate([
    ViewChild('embed', { static: true })
], EmbedComponent.prototype, "embed", void 0);

let GridRowComponent = class GridRowComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.elementRef.nativeElement.classList.add('ui', 'grid');
    }
};
GridRowComponent.ɵfac = function GridRowComponent_Factory(t) { return new (t || GridRowComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
GridRowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GridRowComponent, selectors: [["", "ch-grid-row", ""]], attrs: _c25, ngContentSelectors: _c3, decls: 2, vars: 0, consts: [[1, "row"]], template: function GridRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
GridRowComponent.ctorParameters = () => [
    { type: ElementRef }
];

let DpBtnComponent = class DpBtnComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        this.changeColor();
        $(this.elementRef.nativeElement).dropdown();
    }
    ngOnDestroy() {
        $(this.elementRef.nativeElement).dropdown('destroy');
    }
    changeColor() {
        this.elementRef.nativeElement.className = `ui ${this.color} icon top left pointing dropdown button`;
    }
    get icon() {
        return this._icon || 'settings icon';
    }
    set icon(value) {
        this._icon = value || 'settings icon';
    }
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
        this.changeColor();
    }
    get text() {
        return this._text;
    }
    set text(value) {
        this._text = value;
    }
    get header() {
        return this._header;
    }
    set header(value) {
        this._header = value;
    }
};
DpBtnComponent.ɵfac = function DpBtnComponent_Factory(t) { return new (t || DpBtnComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DpBtnComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DpBtnComponent, selectors: [["", "ch-dp-btn", ""]], inputs: { icon: "icon", color: "color", text: "text", header: "header" }, attrs: _c26, ngContentSelectors: _c3, decls: 5, vars: 3, consts: [["class", "btn-text", 4, "ngIf"], [1, "menu"], ["class", "header", 4, "ngIf"], [1, "btn-text"], [1, "header"]], template: function DpBtnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "i");
        ɵngcc0.ɵɵtemplate(1, DpBtnComponent_span_1_Template, 2, 1, "span", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DpBtnComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.text);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.header);
    } }, directives: [ɵngcc2.NgIf], styles: [".btn-text[_ngcontent-%COMP%]{margin-left:5px}"] });
DpBtnComponent.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input('icon')
], DpBtnComponent.prototype, "icon", null);
__decorate([
    Input('color')
], DpBtnComponent.prototype, "color", null);
__decorate([
    Input('text')
], DpBtnComponent.prototype, "text", null);
__decorate([
    Input('header')
], DpBtnComponent.prototype, "header", null);

let ThSortDirective = class ThSortDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnChanges(changes) {
        if (changes.currentSortField && changes.currentSortField.currentValue) {
            this.currentSortDir = changes.currentSortField.currentValue;
        }
        if (changes.currentSortDir && changes.currentSortDir.currentValue) {
            this.currentSortDir = changes.currentSortDir.currentValue;
        }
        if (changes.sortField && changes.sortField.currentValue) {
            this.sortField = changes.sortField.currentValue;
        }
        this.handleClass();
    }
    get domElem() {
        return this.elementRef.nativeElement;
    }
    get currentSortField() {
        return this._currentSortField;
    }
    set currentSortField(value) {
        this._currentSortField = value;
    }
    get currentSortDir() {
        return this._currentSortDir;
    }
    set currentSortDir(value) {
        this._currentSortDir = value;
    }
    get sortField() {
        return this._sortField;
    }
    set sortField(value) {
        this._sortField = value;
        this.handleClass();
    }
    handleClass() {
        if (!this.currentSortField)
            return;
        if (this.currentSortField == this.sortField) {
            this.domElem.classList.add('sorted', this.currentSortDir === 'asc' ? 'ascending' : 'descending');
            return;
        }
        this.domElem.classList.remove('sorted');
    }
};
ThSortDirective.ɵfac = function ThSortDirective_Factory(t) { return new (t || ThSortDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ThSortDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ThSortDirective, selectors: [["", "ch-th-sort", ""]], inputs: { currentSortDir: ["current-sort-dir", "currentSortDir"], sortField: ["sort-field", "sortField"], currentSortField: ["current-sort-field", "currentSortField"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
ThSortDirective.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input('current-sort-field')
], ThSortDirective.prototype, "currentSortField", null);
__decorate([
    Input('current-sort-dir')
], ThSortDirective.prototype, "currentSortDir", null);
__decorate([
    Input('sort-field')
], ThSortDirective.prototype, "sortField", null);

let NgxChameleonModule = class NgxChameleonModule {
};
NgxChameleonModule.ɵfac = function NgxChameleonModule_Factory(t) { return new (t || NgxChameleonModule)(); };
NgxChameleonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxChameleonModule });
NgxChameleonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            RouterModule
        ]] });

let AlertService = class AlertService {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
    }
    appendComponentToBody() {
        // 1. Create a component reference from the component
        const componentRef = this.componentFactoryResolver
            .resolveComponentFactory(AlertComponent)
            .create(this.injector);
        // 2. Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(componentRef.hostView);
        // 3. Get DOM element from component
        const domElem = componentRef.hostView
            .rootNodes[0];
        // 4. Append DOM element to the body
        document.body.appendChild(domElem);
        // // 5. Wait some time and remove it from the component tree and from the DOM
        // setTimeout(() => {
        //     this.appRef.detachView(componentRef.hostView);
        //     componentRef.destroy();
        // }, 3000);
        this.alertComp = componentRef;
    }
    show(opt) {
        if (!this.alertComp) {
            this.appendComponentToBody();
        }
        setTimeout(() => this.alertComp.instance.open(opt));
    }
    confirm(opt) {
        opt.cancelFn = opt.cancelFn || (() => { });
        if (!this.alertComp) {
            this.appendComponentToBody();
        }
        setTimeout(() => this.alertComp.instance.open(opt));
    }
};
AlertService.ɵfac = function AlertService_Factory(t) { return new (t || AlertService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
AlertService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector }
];
AlertService.ɵprov = ɵɵdefineInjectable({ factory: function AlertService_Factory() { return new AlertService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(ApplicationRef), ɵɵinject(INJECTOR)); }, token: AlertService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[ch-tooltip]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { isInverted: [{
            type: Input,
            args: ['is-inverted']
        }], isHtml: [{
            type: Input,
            args: ['is-html']
        }], position: [{
            type: Input,
            args: ['position']
        }], content: [{
            type: Input,
            args: ['content']
        }], title: [{
            type: Input,
            args: ['title']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SlideDirective, [{
        type: Directive,
        args: [{
                selector: '[ch-slide]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownSelect, [{
        type: Directive,
        args: [{
                selector: '[ch-dropdown-select]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.NgControl, decorators: [{
                type: Self
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: 'ch-alert',
                template: "<div [id]=\"modalId\" class=\"ui tiny modal\">\n  <div *ngIf=\"options?.headerTitle\" class=\"header\">\n    {{options?.headerTitle}}\n  </div>\n  <div class=\"content\">\n    <div *ngIf=\"!options?.isHtml;else htmlMsg;\">\n      {{options?.msg}}\n    </div>\n    <ng-template #htmlMsg>\n      <div [innerHTML]=\"options?.msg\"></div>\n    </ng-template>\n  </div>\n  <div class=\"actions\">\n    <button [attr.class]=\"cancelBtnClass\" *ngIf=\"options?.cancelFn\" (click)=\"cancel()\">\n      {{options?.cancelText}}\n    </button>\n    <button [attr.class]=\"confirmBtnClass\" (click)=\"confirm()\">\n      {{options?.confirmText}}\n    </button>\n  </div>\n</div>\n\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'ch-modal',
                template: "<div [id]=\"modalId\" [attr.class]=\"modalClass\">\n  <i *ngIf=\"showCloseBtn\" class=\"close icon\"></i>\n  <div class=\"header\">\n    {{title}}\n  </div>\n  <div [attr.class]=\"contentClass\">\n    <ng-content>\n\n    </ng-content>\n  </div>\n  <div class=\"actions actions-modal\">\n    <ng-content #actions select=\"[actions]\"></ng-content>\n  </div>\n</div>\n\n\n",
                styles: [""]
            }]
    }], function () { return []; }, { showCloseBtn: [{
            type: Input,
            args: ['show-close-btn']
        }], size: [{
            type: Input,
            args: ['size']
        }], title: [{
            type: Input,
            args: ['title']
        }], isScrolling: [{
            type: Input,
            args: ['is-scrolling']
        }], isScrollingImage: [{
            type: Input,
            args: ['is-scrolling-image']
        }], allowMultiple: [{
            type: Input,
            args: ['allow-multiple']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideBarLinkComponent, [{
        type: Component,
        args: [{
                selector: 'ch-side-bar-link',
                template: "\n\n<li class=\"ch-menu-item ch-dropdown\" *ngIf=\"hasChildren; else noChildrenTemp;\">\n  <a class=\"ch-dropdown-button\" [href]=\"\">\n    <i [attr.class]=\"icon\"></i>\n    <span class=\"ch-menu-item-label\">{{description}}</span>\n    <div class=\"fal fa-chevron-right fa-icon dropdown\"></div>\n  </a>\n  <div class=\"ch-dropdown-content\">\n    <ul class=\"ch-dropdown-menu\">\n      <ng-content>\n      </ng-content>\n    </ul>\n  </div>\n</li>\n\n<ng-template #noChildrenTemp>\n  <li class=\"ch-menu-item\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{exact: exactLink}\">\n    <a [routerLink]=\"route\">\n      <i [attr.class]=\"icon\"></i>\n      <span class=\"ch-menu-item-label\">{{description}}</span>\n    </a>\n  </li>\n</ng-template>\n\n\n",
                styles: [".ch-dropdown-button{cursor:pointer}"]
            }]
    }], function () { return []; }, { route: [{
            type: Input,
            args: ['route']
        }], icon: [{
            type: Input,
            args: ['icon']
        }], description: [{
            type: Input,
            args: ['description']
        }], exactLink: [{
            type: Input,
            args: ['exact-link']
        }], hasChildren: [{
            type: Input,
            args: ['has-children']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideBarComponent, [{
        type: Component,
        args: [{
                selector: '[ch-side-bar]',
                template: "<div class=\"ch-logo\">\n  <div\n    class=\"ch-logo-icon\"\n    [ngStyle]=\"{ width: logo?.width + 'px', height: logo?.height + 'px' }\"\n  >\n    <img\n      [ngStyle]=\"{\n        maxWidth: logo?.width + 'px',\n        maxHeight: logo?.height + 'px'\n      }\"\n      [src]=\"logo?.url || logoUrl || ''\"\n    />\n  </div>\n  <a [href]=\"appUrl || ''\" class=\"app-url\">\n    <span class=\"ch-logo-label\" *ngIf=\"appName\">\n      {{ appName }}\n    </span>\n  </a>\n</div>\n\n<!-- Menu link -->\n<ng-content></ng-content>\n\n<div class=\"ch-expand-button\">\n  <ul class=\"ch-menu\" *ngIf=\"expandButtonData.text\">\n    <li class=\"ch-menu-item\"></li>\n\n    <li class=\"ch-menu-item\">\n      <a [href]=\"\">\n        <i [attr.class]=\"expandButtonIconClass\"></i>\n        <span [attr.class]=\"expandButtonTextClass\">{{\n          expandButtonData?.text\n        }}</span>\n      </a>\n    </li>\n  </ul>\n  <button\n    data-expand=\"Expandir\"\n    data-minimize=\"Minimizar\"\n    (click)=\"changeState()\"\n  >\n    <svg class=\"icon minimize\" width=\"20px\" height=\"15px\" viewBox=\"0 0 20 15\">\n      <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"minimize\" fill=\"#000000\" fill-rule=\"nonzero\">\n          <path\n            d=\"M1.4,2.22044605e-16 L18.6,2.22044605e-16 C19.3731986,8.0010317e-17 20,0.62680135 20,1.4 L20,13.6 C20,14.3731986 19.3731986,15 18.6,15 L1.4,15 C0.62680135,15 5.38778735e-16,14.3731986 4.4408921e-16,13.6 L0,1.4 C-9.46895252e-17,0.62680135 0.62680135,1.42034288e-16 1.4,2.22044605e-16 Z M18.3,1 L9,1 L9,14 L18.3,14 C18.6865993,14 19,13.6865993 19,13.3 L19,1.7 C19,1.31340068 18.6865993,1 18.3,1 Z M6.28125,11.375 L6.5,11.15625 C6.58333375,11.0937497 6.625,11.0104172 6.625,10.90625 C6.625,10.8020828 6.58333375,10.7083337 6.5,10.625 L3.875,8.03125 L9,8.03125 L9,6.96875 L3.875,6.96875 L6.5,4.375 C6.58333375,4.29166625 6.625,4.19791719 6.625,4.09375 C6.625,3.98958281 6.58333375,3.90625031 6.5,3.84375 L6.28125,3.625 C6.19791625,3.54166625 6.10937547,3.5 6.015625,3.5 C5.92187453,3.5 5.83333375,3.54166625 5.75,3.625 L2.125,7.25 C2.04166625,7.31250031 2,7.39583281 2,7.5 C2,7.60416719 2.04166625,7.68749969 2.125,7.75 L5.75,11.375 C5.83333375,11.4583337 5.92187453,11.5 6.015625,11.5 C6.10937547,11.5 6.19791625,11.4583337 6.28125,11.375 Z\"\n            id=\"path-1\"\n          ></path>\n        </g>\n      </g>\n    </svg>\n    <svg class=\"icon expand\" width=\"20px\" height=\"15px\" viewBox=\"0 0 20 15\">\n      <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"expand\" fill=\"#000000\" fill-rule=\"nonzero\">\n          <path\n            d=\"M1.4,2.22044605e-16 L18.6,2.22044605e-16 C19.3731986,8.0010317e-17 20,0.62680135 20,1.4 L20,13.6 C20,14.3731986 19.3731986,15 18.6,15 L1.4,15 C0.62680135,15 5.38778735e-16,14.3731986 4.4408921e-16,13.6 L0,1.4 C-9.46895252e-17,0.62680135 0.62680135,1.42034288e-16 1.4,2.22044605e-16 Z M18.3,1 L4,1 L4,14 L18.3,14 C18.6865993,14 19,13.6865993 19,13.3 L19,1.7 C19,1.31340068 18.6865993,1 18.3,1 Z M6.71875,11.375 L6.5,11.15625 C6.41666625,11.0937497 6.375,11.0104172 6.375,10.90625 C6.375,10.8020828 6.41666625,10.7083337 6.5,10.625 L9.125,8.03125 L4,8.03125 L4,6.96875 L9.125,6.96875 L6.5,4.375 C6.41666625,4.29166625 6.375,4.19791719 6.375,4.09375 C6.375,3.98958281 6.41666625,3.90625031 6.5,3.84375 L6.71875,3.625 C6.80208375,3.54166625 6.89062453,3.5 6.984375,3.5 C7.07812547,3.5 7.16666625,3.54166625 7.25,3.625 L10.875,7.25 C10.9583337,7.31250031 11,7.39583281 11,7.5 C11,7.60416719 10.9583337,7.68749969 10.875,7.75 L7.25,11.375 C7.16666625,11.4583337 7.07812547,11.5 6.984375,11.5 C6.89062453,11.5 6.80208375,11.4583337 6.71875,11.375 Z\"\n            id=\"path-1\"\n          ></path>\n        </g>\n      </g>\n    </svg>\n  </button>\n</div>\n",
                styles: ["a.app-url,a.app-url:active,a.app-url:hover,a.app-url:visited{text-decoration:none;color:#fff!important}.text.white{color:#fff}.text.grey{color:#ccc}.text.black{color:#1b1c1d}.text.yellow{color:#f2c61f}.text.teal{color:#00b5ad}.text.red{color:#d95c5c}.text.purple{color:#564f8a}.text.pink{color:#d9499a}.text.orange{color:#e07b53}.text.green{color:#5bbd72}.text.blue{color:#3b83c0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { appName: [{
            type: Input,
            args: ['app-name']
        }], appUrl: [{
            type: Input,
            args: ['app-url']
        }], expandButtonData: [{
            type: Input,
            args: ['expand-button-data']
        }], logoOptions: [{
            type: Input,
            args: ['logo-options']
        }], logoUrl: [{
            type: Input,
            args: ['logo-url']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideBarMenuComponent, [{
        type: Component,
        args: [{
                selector: 'ch-side-bar-menu',
                template: "<ul class=\"ch-menu\">\n  <ng-content></ng-content>\n  <li class=\"ch-menu-item more mobile-only\">\n    <button data-toogle=\"nav\">\n      <i class=\"fal fa-ellipsis-h-alt fa-icon\"></i>\n    </button>\n  </li>\n</ul>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopBarComponent, [{
        type: Component,
        args: [{
                selector: '[ch-top-bar]',
                template: "<div ch-top-bar-breadcrumb></div>\n<ng-content>\n</ng-content>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopBarBreadcrumbService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopBarBreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: '[ch-top-bar-breadcrumb]',
                template: "<ng-container *ngIf=\"paths.length === 0\">\n  <div class=\"ch-breadcrumb-section active\">\n    <a [href]=\"\" [title]=\"title || ''\">\n      <i *ngIf=\"path && icon\" [attr.class]=\"icon\"> </i>\n      <span *ngIf=\"path\">\n        {{ path }}\n      </span>\n    </a>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"paths.length > 0\">\n  <div\n    class=\"ch-breadcrumb-section\"\n    *ngFor=\"let item of paths; let i = index\"\n    [ngClass]=\"{ active: item.active }\"\n  >\n    <a\n      [title]=\"item.title || ''\"\n      [routerLink]=\"item.route\"\n      [queryParams]=\"item.queryParams\"\n      *ngIf=\"item.route; else noNavigation\"\n    >\n      <ng-template\n        [ngTemplateOutlet]=\"tplItem\"\n        [ngTemplateOutletContext]=\"{ $implicit: { item: item, i: i } }\"\n      ></ng-template>\n    </a>\n    <ng-template #noNavigation>\n      <a [title]=\"item.title || ''\" [href]=\"\">\n        <ng-template\n          [ngTemplateOutlet]=\"tplItem\"\n          [ngTemplateOutletContext]=\"{ $implicit: { item: item, i: i } }\"\n        ></ng-template>\n      </a>\n    </ng-template>\n  </div>\n</ng-container>\n\n<ng-template #tplItem let-data>\n  <i *ngIf=\"icon && data.i == 0\" [attr.class]=\"icon\"> </i>\n  <span *ngIf=\"data.i > 0\" class=\"m-r-10 m-l-5\">/</span>\n  <span>\n    {{ data.item.title }}\n  </span>\n</ng-template>\n",
                styles: [".path-selector{cursor:pointer I!important}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: TopBarBreadcrumbService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopBarMenuComponent, [{
        type: Component,
        args: [{
                selector: 'ch-top-bar-menu',
                template: "<div class=\"ch-header-nav animated\">\n\n  <ng-content>\n\n  </ng-content>\n\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchFormComponent, [{
        type: Component,
        args: [{
                selector: '[ch-search-form]',
                template: "<ng-container *ngIf=\"withTooltip; else withoutTooltipTem\">\n  <div [attr.class]=\"'tiny ui icon buttons ' + defaultSearchBtnPosition\">\n    <button [attr.class]=\"'ui ' + color + ' button' + (hidden ? ' basic' : '')\" [ngClass]=\"{'basic': hidden}\"\n      (click)=\"toggle($event)\" ch-tooltip [content]=\"hidden ? hiddenSearchBtnTooltip : visibleSearchBtnTooltip\"\n      [is-inverted]=\"tootipIsInverted\" [position]=\"tootipIsInvertedPosition\" [is-html]=\"false\">\n      <i class=\"fas fa-filter\"></i>\n    </button>\n\n    <button [attr.class]=\"'ui ' + color + ' button basic'\" [ngClass]=\"{'loading': loading}\" (click)=\"search()\"\n      ch-tooltip [content]=\"updateBtnTooltip\" [is-inverted]=\"tootipIsInverted\" [is-html]=\"false\"\n      [position]=\"tootipIsInvertedPosition\">\n      <i class=\"fas fa-sync\"></i>\n    </button>\n  </div>\n\n\n</ng-container>\n\n<ng-template #withoutTooltipTem>\n  <div [attr.class]=\"'tiny ui icon buttons ' + defaultSearchBtnPosition\">\n    <button [attr.class]=\"'ui ' + color + ' button' + (hidden ? ' basic' : '')\" [ngClass]=\"{'basic': hidden}\"\n    (click)=\"toggle($event)\">\n      <i class=\"fas fa-filter\"></i>\n    </button>\n\n    <button [attr.class]=\"'ui ' + color + ' button basic'\" [ngClass]=\"{'loading': loading}\" (click)=\"search()\">\n      <i class=\"fas fa-sync\"></i>\n    </button>\n  </div>\n\n</ng-template>\n<div [attr.class]=\"extraBtnPosition\">\n  <ng-content select=\"[extra-buttons]\"></ng-content>\n</div>\n\n<div class=\"clear-fix\"></div>\n<ch-transiction-fade [hidden]=\"hidden\">\n  <div class=\"ui form\">\n    <h4 class=\"ui dividing header\"></h4>\n    <ng-content></ng-content>\n    <div>\n      <button class=\"ui orange basic button\" (click)=\"clear()\">\n        <i class=\"fas fa-eraser fa-icon\"></i>\n        {{clearBtnText}}\n      </button>\n      <button [attr.class]=\"'ui ' + color + ' basic button'\" (click)=\"search()\">\n        <i class=\"fas fa-search fa-icon\"></i>\n        {{searchBtnText}}\n      </button>\n    </div>\n    <h4 class=\"ui dividing header\"></h4>\n  </div>\n</ch-transiction-fade>\n",
                styles: [".float-left{float:left;margin-left:auto}.float-right{float:right;margin-right:auto}.clear-fix{clear:both}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { title: [{
            type: Input,
            args: ['title']
        }], clearBtnText: [{
            type: Input,
            args: ['clearBtnText']
        }], searchBtnText: [{
            type: Input,
            args: ['searchBtnText']
        }], hiddenSearchBtnTooltip: [{
            type: Input,
            args: ['hiddenSearchBtnTooltip']
        }], visibleSearchBtnTooltip: [{
            type: Input,
            args: ['visibleSearchBtnTooltip']
        }], updateBtnTooltip: [{
            type: Input,
            args: ['updateBtnTooltip']
        }], loading: [{
            type: Input,
            args: ['loading']
        }], tootipIsInverted: [{
            type: Input,
            args: ['tootipIsInverted']
        }], tootipIsInvertedPosition: [{
            type: Input,
            args: ['tootipIsInvertedPosition']
        }], withTooltip: [{
            type: Input,
            args: ['with-tooltip']
        }], color: [{
            type: Input,
            args: ['color']
        }], hidden: [{
            type: Input,
            args: ['is-hidden']
        }], onClear: [{
            type: Output,
            args: ['on-clear']
        }], onSearch: [{
            type: Output,
            args: ['on-search']
        }], onChange: [{
            type: Output
        }], searchBtnPosition: [{
            type: Input,
            args: ['searchBtnPosition']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IdGeneratorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopBarLoaderServiceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GridColumnComponent, [{
        type: Component,
        args: [{
                selector: '[ch-grid-column]',
                template: "<ng-content>\n\n</ng-content>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { tablet: [{
            type: Input,
            args: ['tablet']
        }], computer: [{
            type: Input,
            args: ['computer']
        }], centered: [{
            type: Input,
            args: ['centered']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HDividerComponent, [{
        type: Component,
        args: [{
                selector: '[ch-hdivider],[ch-divider]',
                template: "\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TransictionFadeComponent, [{
        type: Component,
        args: [{
                selector: 'ch-transiction-fade',
                template: "\n<div [id]=\"id\" class=\"ui transition\" [ngClass]=\"{'hidden': hidden}\">\n  <ng-content></ng-content>\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { hidden: [{
            type: Input,
            args: ['hidden']
        }], direction: [{
            type: Input,
            args: ['direction']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{
                selector: 'ch-dialog',
                template: "<div [id]=\"ids.dialog\" class=\"ch-dialog\" tabindex=\"0\">\n  <div [id]=\"ids.overlay\" class=\"ch-overlay\">\n    <div [id]=\"ids.dialogContainer\" class=\"ch-dialog-container\" [ngStyle]=\"{width: width}\">\n      <div class=\"ch-dialog-header\">\n        <div class=\"content\">\n          <div class=\"title\" *ngIf=\"title\">\n            <div *ngIf=\"titleIsHtml; else elseTitle;\" [innerHTML]=\"title\"></div>\n            <ng-template #elseTitle>\n                <span>{{title}}</span>\n            </ng-template>\n          </div>\n        </div>\n        <div class=\"actions\">\n          <a [href]=\"\" (click)=\"close()\" class=\"button\">\n            <i class=\"close icon\"></i>\n          </a>\n\n        </div>\n      </div>\n      <div class=\"ch-dialog-content\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: ["i.close.icon{cursor:pointer}"]
            }]
    }], function () { return [{ type: IdGeneratorService }]; }, { titleIsHtml: [{
            type: Input,
            args: ['title-is-html']
        }], closeOnClick: [{
            type: Input,
            args: ['close-on-click']
        }], width: [{
            type: Input,
            args: ['width']
        }], duration: [{
            type: Input,
            args: ['duration']
        }], title: [{
            type: Input,
            args: ['title']
        }], onClose: [{
            type: Input,
            args: ['on-close']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PointingLabelComponent, [{
        type: Component,
        args: [{
                selector: 'ch-pointing-label',
                template: "<div [attr.class]=\"cssClass\">\n  <ng-content></ng-content>\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { color: [{
            type: Input,
            args: ['color']
        }], position: [{
            type: Input,
            args: ['position']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionComponent, [{
        type: Component,
        args: [{
                selector: '[ch-accordion]',
                template: "<ng-content></ng-content>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionContentComponent, [{
        type: Component,
        args: [{
                selector: '[ch-accordion-content]',
                template: "<ng-content></ng-content>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionTitleComponent, [{
        type: Component,
        args: [{
                selector: '[ch-accordion-title]',
                template: "<i class=\"dropdown icon\"></i>\n<ng-content></ng-content>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EmbedComponent, [{
        type: Component,
        args: [{
                selector: 'ch-embed',
                template: "<div class=\"ui embed\" #embed></div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { url: [{
            type: Input,
            args: ['url']
        }], embed: [{
            type: ViewChild,
            args: ['embed', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GridRowComponent, [{
        type: Component,
        args: [{
                selector: '[ch-grid-row]',
                template: "<div class=\"row\">\n  <ng-content></ng-content>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DpBtnComponent, [{
        type: Component,
        args: [{
                selector: '[ch-dp-btn]',
                template: "<i [attr.class]=\"icon\"></i>\n<span class=\"btn-text\" *ngIf=\"text\">{{text}}</span>\n<div class=\"menu\">\n  <div class=\"header\" *ngIf=\"header\">{{header}}</div>\n  <ng-content></ng-content>\n</div>\n",
                styles: [".btn-text{margin-left:5px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { icon: [{
            type: Input,
            args: ['icon']
        }], color: [{
            type: Input,
            args: ['color']
        }], text: [{
            type: Input,
            args: ['text']
        }], header: [{
            type: Input,
            args: ['header']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ThSortDirective, [{
        type: Directive,
        args: [{
                selector: '[ch-th-sort]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { currentSortDir: [{
            type: Input,
            args: ['current-sort-dir']
        }], sortField: [{
            type: Input,
            args: ['sort-field']
        }], currentSortField: [{
            type: Input,
            args: ['current-sort-field']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxChameleonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SlideDirective,
                    DropdownSelect,
                    TooltipDirective,
                    ThSortDirective,
                    AlertComponent,
                    ModalComponent,
                    SideBarLinkComponent,
                    SideBarComponent,
                    SideBarMenuComponent,
                    TopBarComponent,
                    TopBarBreadcrumbComponent,
                    TopBarMenuComponent,
                    SearchFormComponent,
                    GridRowComponent,
                    GridColumnComponent,
                    HDividerComponent,
                    TransictionFadeComponent,
                    DialogComponent,
                    PointingLabelComponent,
                    AccordionComponent,
                    AccordionContentComponent,
                    AccordionTitleComponent,
                    EmbedComponent,
                    DpBtnComponent,
                ],
                imports: [
                    CommonModule,
                    RouterModule
                ],
                exports: [
                    SlideDirective,
                    DropdownSelect,
                    TooltipDirective,
                    ThSortDirective,
                    AlertComponent,
                    ModalComponent,
                    SideBarLinkComponent,
                    SideBarComponent,
                    SideBarMenuComponent,
                    TopBarComponent,
                    TopBarBreadcrumbComponent,
                    TopBarMenuComponent,
                    SearchFormComponent,
                    GridRowComponent,
                    GridColumnComponent,
                    HDividerComponent,
                    TransictionFadeComponent,
                    DialogComponent,
                    PointingLabelComponent,
                    AccordionComponent,
                    AccordionContentComponent,
                    AccordionTitleComponent,
                    EmbedComponent,
                    DpBtnComponent
                ],
                entryComponents: [
                    AlertComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxChameleonModule, { declarations: function () { return [SlideDirective, DropdownSelect, TooltipDirective, ThSortDirective, AlertComponent, ModalComponent, SideBarLinkComponent, SideBarComponent, SideBarMenuComponent, TopBarComponent, TopBarBreadcrumbComponent, TopBarMenuComponent, SearchFormComponent, GridRowComponent, GridColumnComponent, HDividerComponent, TransictionFadeComponent, DialogComponent, PointingLabelComponent, AccordionComponent, AccordionContentComponent, AccordionTitleComponent, EmbedComponent, DpBtnComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [SlideDirective, DropdownSelect, TooltipDirective, ThSortDirective, AlertComponent, ModalComponent, SideBarLinkComponent, SideBarComponent, SideBarMenuComponent, TopBarComponent, TopBarBreadcrumbComponent, TopBarMenuComponent, SearchFormComponent, GridRowComponent, GridColumnComponent, HDividerComponent, TransictionFadeComponent, DialogComponent, PointingLabelComponent, AccordionComponent, AccordionContentComponent, AccordionTitleComponent, EmbedComponent, DpBtnComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();

var AlertEventsType;
(function (AlertEventsType) {
    AlertEventsType[AlertEventsType["Show"] = 0] = "Show";
    AlertEventsType[AlertEventsType["Hide"] = 1] = "Hide";
})(AlertEventsType || (AlertEventsType = {}));

/*
 * Public API Surface of ngx-chameleon
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AccordionContentComponent, AccordionTitleComponent, AlertComponent, AlertEventsType, AlertService, DialogComponent, DpBtnComponent, DropdownSelect, EmbedComponent, FadeDirection, GridColumnComponent, GridRowComponent, HDividerComponent, IdGeneratorService, ModalComponent, NgxChameleonModule, NumberValues, PointingLabelComponent, SearchFormComponent, SideBarComponent, SideBarLinkComponent, SideBarMenuComponent, SlideDirective, ThSortDirective, TooltipDirective, TopBarBreadcrumbComponent, TopBarBreadcrumbService, TopBarComponent, TopBarLoaderServiceService, TopBarMenuComponent, TransictionFadeComponent };

